// extracted by mini-css-extract-plugin
module.exports = {"calendarExample":"index_calendarExample_31AB_"};